export default {"src":"/pro/_next/static/media/vrtx.74dd4d49.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};